import { Injectable } from '@angular/core'
import { Subject, Observable } from "rxjs/Rx"
// import { ReplaySubject } from 'rxjs/ReplaySubject';

declare var firebase: any

export interface Brand {
  id:string,
  name:string,
  desc:string,
  createdAt:number,
  updatedAt:number,
  storeCount:number,
  enabled:boolean,
  prepaidEnabled:boolean,
  prepaidMax:number,
  pointEnabled:boolean,
  imageURL:string,
  tags:string[],
  productTags:string[]
}

@Injectable()
export class BrandsService {
  // brandsListener:any
  // brandsSubject:ReplaySubject<any[]>

  currentBrand:Brand
  currentBrandId:string
  currentBrandStoreCount:number

  constructor() { }

  getBrands(){
    return firebase.firestore().collection("brands").get()
    // if (!this.brandsSubject) {
    //     this.brandsSubject = new ReplaySubject(1)
    //     this.brandsListener = firebase.firestore().collection("brands").onSnapshot(
    //       (collection) => {
    //         let array = []
    //         collection.forEach(
    //           (doc) => {
    //             let b = doc.data()
    //             b.id = doc.id
    //             array.push(b)
    //           }
    //         )
    //         this.brandsSubject.next(array)
    //       }
    //     )
    // }
    // return this.brandsSubject.asObservable()
  }

  getBrand(id:string) {
    return firebase.firestore().collection("brands").doc(id).get()
    // return this.getBrands().map(
    //   brands => {
    //     return brands.filter(brand => {return brand.id == id})[0]
    //   }
    // )
  }

  getBrandTag(id:string) {
    return firebase.firestore().collection("brands").doc(id).get()
    // return this.getBrands().map(
    //   brands => {
    //     return brands.filter(brand => {return brand.id == id})[0]
    //   }
    // )
  } 

  uploadBrandImage(file:File) {
    let metadata = {
        contentType: file.type
    }

    let array = file.type.split('/')
    let type = ""
    if (array.length > 1) {
        type = array[1]
    }

    let ref = firebase.storage().ref().child('brandImages/'+Date.now()+"."+type)
    return ref.put(file)
  }

  createBrand(brandInfo:Brand) {
    brandInfo.createdAt = Date.now()
    brandInfo.updatedAt = Date.now()
    brandInfo.storeCount = 0
    return firebase.firestore().collection("brands").add(brandInfo)
  }

  updateBrand(id:string,brandInfo:Brand) {
    brandInfo.updatedAt = Date.now()
    return firebase.firestore().collection("brands").doc(id).update(brandInfo)
  }

  deleteBrand(id:string) {
    return firebase.firestore().collection("brands").doc(id).delete()
  }
}



// WEBPACK FOOTER //
// ./src/app/services/brands.service.ts